import { API } from "@/services"

export const CORS_ALLOWED_DOMAINS_ENDPOINTS = {
  create(data={}){
    return API.Axios.error_capture.v1.request({
      url: `cors-allowed-domain`,
      method: 'POST',
      data,
    })
  },
  get(params={}){
    return API.Axios.error_capture.v1.request({
      url: `cors-allowed-domain`,
      method: 'GET',
      params,
    })
  },
  findById(id,params={}){
    return API.Axios.error_capture.v1.request({
      url: `cors-allowed-domain/${id}`,
      method: 'GET',
      params,
    })
  },
  delete(id='',data={}){
    return API.Axios.error_capture.v1.request({
      url: `cors-allowed-domain/${id}`,
      method: 'DELETE',
      data,
    })
  },
  update(id='',data={}){
    return API.Axios.error_capture.v1.request({
      url: `cors-allowed-domain/${id}`,
      method: 'PUT',
      data,
    })
  },
}